import { createSlice } from "@reduxjs/toolkit";
import { Vendor } from "../models/Vendor";

const VendorsInitialState: {
	vendors: Vendor[];
} = {
	vendors: [],
};

export const VendorsReducer = createSlice({
	name: "__",
	initialState: VendorsInitialState,
	reducers: {
		setVendors(state, { payload }) {
			state.vendors = payload;
		},
	},
});
